export default "__VITE_ASSET__CpeLCw59__"